/*
 * @Desc: 
 * @Author: lc
 * @Date: 2023-09-19 08:48:08
 * @LastEditors: lc
 * @LastEditTime: 2023-09-24 11:47:15
 */
const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  admin_id: state => state.user.admin_id,
  isupd: state => state.user.isupd,
  permission_routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  errorLogs: state => state.errorLog.logs
}
export default getters
